import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';

const ROW_A = [
  'React', 'TypeScript', 'Node.js', 'AWS', 'Azure', 'Kubernetes',
  'Docker', 'GraphQL', 'PostgreSQL', 'Terraform',
];
const ROW_B = [
  'Swift', 'Kotlin', 'Flutter', 'React Native', '.NET', 'C++',
  'Python', 'Go', 'Salesforce', 'NetSuite',
];

function Track({ items, reverse }) {
  const doubled = [...items, ...items];
  return (
    <Box
      sx={{
        display: 'flex',
        width: 'max-content',
        gap: 2,
        animation: `fx-marquee ${reverse ? '38s' : '32s'} linear infinite`,
        animationDirection: reverse ? 'reverse' : 'normal',
        '&:hover': { animationPlayState: 'paused' },
      }}
    >
      {doubled.map((label, i) => (
        <Box
          key={`${label}-${i}`}
          sx={{
            flex: '0 0 auto',
            px: 2.5,
            py: 1.25,
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
            bgcolor: (t) =>
              t.palette.mode === 'dark' ? 'hsla(220,30%,12%,0.5)' : 'hsla(0,0%,100%,0.7)',
            backdropFilter: 'blur(6px)',
            fontFamily: '"JetBrains Mono", monospace',
            fontSize: '0.9rem',
            fontWeight: 500,
            color: 'text.secondary',
            transition: 'all 0.25s ease',
            whiteSpace: 'nowrap',
            '&:hover': {
              color: 'text.primary',
              borderColor: 'primary.main',
              transform: 'translateY(-2px)',
            },
          }}
        >
          {label}
        </Box>
      ))}
    </Box>
  );
}

export default function TechMarquee() {
  return (
    <Box sx={{ py: { xs: 5, sm: 7 } }}>
      <Container>
        <Typography
          variant="caption"
          sx={{
            display: 'block',
            textAlign: 'center',
            mb: 3.5,
            letterSpacing: 2,
            textTransform: 'uppercase',
            fontWeight: 700,
            color: 'text.secondary',
            opacity: 0.8,
          }}
        >
          The stack we build with
        </Typography>
      </Container>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          maskImage: 'linear-gradient(90deg, transparent, black 12%, black 88%, transparent)',
          WebkitMaskImage: 'linear-gradient(90deg, transparent, black 12%, black 88%, transparent)',
          overflow: 'hidden',
        }}
      >
        <Track items={ROW_A} />
        <Track items={ROW_B} reverse />
      </Box>
    </Box>
  );
}
